import { countWordsIncludingMarkup } from './wordcount'

export const MAX_BLURB_TRANSLATION_WORDS = 1000

export const normalizeMetadataFreeRunLanguageKey = (language: unknown): string => {
  const value = String(language || '').trim().toLowerCase()
  const key = value.replace(/[^a-z0-9]+/g, '_').replace(/^_+|_+$/g, '')
  return key || 'unknown'
}

export const metadataFreeRunConsumed = (
  freeRuns: unknown,
  language: unknown,
): boolean => {
  if (!freeRuns || typeof freeRuns !== 'object') return false
  const key = normalizeMetadataFreeRunLanguageKey(language)
  return Boolean((freeRuns as Record<string, unknown>)[key])
}

export const getBlurbWordCount = (value: unknown): number =>
  countWordsIncludingMarkup(typeof value === 'string' ? value : '')

export const isBlurbOverWordLimit = (
  value: unknown,
  maxWords = MAX_BLURB_TRANSLATION_WORDS,
): boolean => getBlurbWordCount(value) > maxWords

export const formatBlurbWordLimitMessage = (
  wordCount: number,
  maxWords = MAX_BLURB_TRANSLATION_WORDS,
): string => `Blurb must be ${maxWords.toLocaleString()} words or fewer. Current length: ${wordCount.toLocaleString()} words.`
